class ScrollDragHandler {
    constructor({
        scrollableEl,
        scroll,
        onUpdateScroll,
        scrollDelta = 10,
        scrollOffset = 100
    }) {
        this.scrollableEl = scrollableEl
        this.scroll = scroll
        this.onUpdateScroll = onUpdateScroll
        this.scrollDelta = scrollDelta
        this.scrollOffset = scrollOffset
    }

    clearAutoScrollTimer() {
        clearTimeout(this.autoScrollTimer)
    }

    handleEvent(event) {
    }

    _autoScroll(x, y) {
        this.onUpdateScroll()
        this.clearAutoScrollTimer()

        this.autoScrollTimer = setInterval(() => {
            this.scroll.scrollBy(x, y);
            this.onUpdateScroll()
        }, 5)
    }

}

class VerticalScrollDragHandler extends ScrollDragHandler {
    handleEvent(event) {
        const top = this.scrollableEl.offset().top
        const bottom = this.scrollableEl.offset().top + this.scrollableEl.outerHeight()

        if (event.clientY > bottom - this.scrollOffset && this.scroll.y > this.scroll.maxScrollY) {
            this._autoScroll(0, -this.scrollDelta)
        } else if (event.clientY < top + this.scrollOffset && this.scroll.y < 0) {
            this._autoScroll(0, this.scrollDelta)
        } else {
            this.clearAutoScrollTimer()
        }
    }
}

class HorizonalScrollDragHandler extends ScrollDragHandler {
    handleEvent(event) {
        const left = this.scrollableEl.offset().left
        const right = this.scrollableEl.offset().left + this.scrollableEl.outerWidth()

        if (event.pageX < left + this.scrollOffset && this.scroll.x < 0) {
            this._autoScroll(this.scrollDelta, 0)
        } else if (event.pageX > right - this.scrollOffset && this.scroll.x > this.scroll.maxScrollX) {
            this._autoScroll(-this.scrollDelta, 0)
        } else {
            this.clearAutoScrollTimer()
        }
    }
}


export {
    VerticalScrollDragHandler,
    HorizonalScrollDragHandler
}




// WEBPACK FOOTER //
// ./web/js/util/ScrollDragHandler.js